import { getProductDict } from '@/server/device'
import { domainid, typeOf } from '@/utils/utils'

export default async function (category_id) {
  const public_res = await getProductDict({
    product_category: category_id,
    field: 'product_category,product_name,product_key,id,domain_id',
  })
  const private_res = await getProductDict({
    product_category: category_id,
    field: 'product_category,product_name,product_key',
    domain_id: domainid(),
  })

  if (typeOf(private_res.data.msg) === 'object' && Object.keys(private_res.data.msg).length) {
    private_res.data.msg = [private_res.data.msg]
  }

  let options = public_res.data.msg
    .map(item => {
      return {
        label: item.product_name,
        value: item.product_key,
        category: item.product_category,
        type: '公共',
      }
    })
    .concat(
      private_res.data.msg.map(item => {
        return {
          label: item.product_name,
          value: item.product_key,
          category: item.product_category,
          type: '私有',
        }
      }),
    )

  return options
}
